import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { tile } from '../styles.module.css';
import {
  image,
  eventTitle as eventTitleStyle,
  eventLocation,
  eventDate,
  dateReviewContainer,
  reviewStar,
  reviewCount as reviewCountStyle,
  reviewRating as reviewRatingStyle,
} from './styles.module.css';

const EventTile = ({ event, onClick }) => {
  const {
    id,
    title: eventTitle,
    startDate,
    place: {
      address: { city },
    },
    images: {
      hero: { medium: eventImage },
    },
    reviewSummary,
    permalink,
  } = event;

  const mStartDate = moment(startDate);
  const startDateText =
    mStartDate.year() === moment().year()
      ? mStartDate.format('D MMM')
      : mStartDate.format('D MMM YY');

  return (
    <Link
      to={permalink}
      target="_blank"
      className={tile}
      onClick={() => onClick && onClick({ eventId: id })}
    >
      <img className={image} src={eventImage} alt={eventTitle} />
      <span className={eventTitleStyle}>{eventTitle}</span>
      <span className={eventLocation}>{city}</span>
      <div className={dateReviewContainer}>
        <span className={eventDate}>{startDateText}</span>
        {reviewSummary && (
          <span>
            <span className={reviewRatingStyle}>
              {reviewSummary?.ratings?.overall}
            </span>
            <Star className={reviewStar} />
            <span className={reviewCountStyle}>({reviewSummary?.total})</span>
          </span>
        )}
      </div>
    </Link>
  );
};

const Star = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.906 10.874l-3.418 1.757c-.586.301-.97.024-.854-.635l.648-3.695-2.755-2.626c-.48-.457-.332-.904.319-.996l3.82-.543L55.365.774c.3-.593.782-.6 1.084 0l1.698 3.362 3.82.543c.656.093.8.538.32.996L59.53 8.3l.648 3.695c.114.652-.272.934-.854.635l-3.418-1.757z"
      transform="translate(-49)"
      fill="#FFC412"
    />
  </svg>
);

export default EventTile;
